import React, { useEffect } from "react";

import Prism from "prismjs";
import {
  jsEcommerce,
  wordPress,
  reactProject,
  snakeGameProject,
} from "../data/projectsData";
import Header from "../components/Layout/header";
import Footer from "../components/Layout/footer";
import { ProjectSection } from "../components/UI/projectCard";
import { BITCard } from "../components/UI/blockInTextCard";


export default function Projects() {
  

  useEffect(() => {
    Prism.highlightAll();
  }, []);

  const projectData = [wordPress, reactProject, snakeGameProject, jsEcommerce];

  return (
    <div className="bg-white">
      <Header />

      {projectData.map((project) => (
        <div key={project.pjName} className="bg-white">
          <ProjectSection
            pjName={project.pjName}
            pjdescrip={project.pjdescrip}
            techShare={project.techShare}
          />
        </div>

      ))}


      <BITCard />
      <Footer />
    </div>
  );
}
